import { handleActions } from 'redux-actions';
import { TranslatedCollectionToCanonical } from 'ha/constants/SearchPageCollections';
import { Actions } from '../constants';

const initialState = {
  collection: '',
  categories: [],
};

export default handleActions(
  {
    [Actions.UPDATE_SEARCH_PARAMS]: (
      _,
      // TODO: Localized kind is a bad name for that part of the URL
      { payload: { localizedKind, categories = [] } },
    ) => ({
      collection: localizedKind
        ? TranslatedCollectionToCanonical[localizedKind]
        : '',
      categories: Array.isArray(categories) ? categories : [categories],
    }),
  },
  initialState,
);

export const getCollection = state => state.collection;
export const getCategories = state => state.categories;
